import { Injectable } from '@angular/core';
import { ButtonActionComponent } from '@shared/.';

@Injectable({
  providedIn: 'root',
})
export class ButtonActionPresenter {
  view!: ButtonActionComponent;

  setView(view: ButtonActionComponent): void {
    this.view = view;
  }

  onSave(): void {
    this.view.actionSaveTriggered.emit();
  }

  onCreate(): void {
    this.view.actionCreateTriggered.emit();
  }

  onCreateCopy(): void {
    this.view.actionCreateCopyTriggered.emit();
  }

  onSaveCopy(): void {
    this.view.actionCreateCopyTriggered.emit();
  }

  onCancel(): void {
    this.view.actionCancelTriggered.emit();
  }
}
